export class HTTP{

    static get(url, response){
        var xmlHttp = new XMLHttpRequest();

        xmlHttp.onreadystatechange = function() { 
            if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
            response(xmlHttp.responseText);
        }

        xmlHttp.open( "GET", url, true ); // false for synchronous request
        xmlHttp.send( null );
    }

}